import { SDUIOnClickHandler } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUITileInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/types";
import { SDUITypographyRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { Column } from "@faire/web/slate/Layout";
import React from "react";

export const SDUITextTileRenderer = ({
  tileElement,
  loggingData,
}: SDUITileInstanceRendererProps) => {
  const { on_click, text_tile } = tileElement;
  const { texts } = text_tile ?? {};
  if (!texts || texts.length === 0) {
    return null;
  }

  return (
    <SDUIOnClickHandler
      onClickActions={on_click}
      loggingData={loggingData}
      logLegacyClickEvent
    >
      <Column gap="1x">
        {texts.map((textElement, i) => (
          <SDUITypographyRenderer
            key={`${i}-${textElement.logging_data?.instance_identifier}`}
            textElement={textElement}
            loggingData={loggingData}
          />
        ))}
      </Column>
    </SDUIOnClickHandler>
  );
};
